import React, { useCallback } from 'react';
import { faBolt, faBoltSlash, faEllipsisV, faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ePermissions } from '../../../../types/administration/userAdministration/ePermissions';
import { ButtonDropdown } from 'ui-toolkit';
import { IFeatureGlobalData, IFeatureRoleData } from '../../../../types/administration/features/IFeature';
import { RedGreenOptions } from '../../subComponents/RedGreenOptions';
import { PermissionWrapper } from '../../../accessControl/PermissionWrapper';
import { useDeleteFeatureRoleMutation, useUpdateFeatureRoleMutation } from '../../../../API/administration/FeaturesAPI';
import { checkForMutationSuccess } from '../../../../API/checkForMutationSuccess';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { SerializedError } from '@reduxjs/toolkit';

interface IFeatureMenuDropdownProps {
  feature: IFeatureRoleData;
}

export const isResponseOnOrOff = (
  response: { data: IFeatureGlobalData } | { error: FetchBaseQueryError | SerializedError }
) => {
  if ('data' in response) {
    return response.data.isOn ? 'ON' : 'OFF';
  }
  return 'ERROR';
};

export const FeatureRoleMenuDropdown: React.FC<IFeatureMenuDropdownProps> = ({ feature }) => {
  const [updateFeatureRole] = useUpdateFeatureRoleMutation();
  const [deleteFeatureRole] = useDeleteFeatureRoleMutation();

  const onUpdateFeatureRole = useCallback(async () => {
    const response = await updateFeatureRole({ name: feature.name, roleId: feature.roleId, isOn: !feature.isOn });
    checkForMutationSuccess(response, `Feature Role is now ${isResponseOnOrOff(response)}`);
  }, [updateFeatureRole, feature]);

  const onDeleteFeatureRole = useCallback(async () => {
    const response = await deleteFeatureRole({ name: feature.name, roleId: feature.roleId });
    checkForMutationSuccess(response, 'Feature Role Deletion');
  }, [deleteFeatureRole, feature]);

  return (
    <PermissionWrapper allowedPermissions={[ePermissions.FeatureEdit]}>
      <ButtonDropdown
        intent={'ghost'}
        children={<FontAwesomeIcon icon={faEllipsisV} />}
        items={[
          {
            children: <RedGreenOptions isEnabled={feature.isOn} activeIcon={faBolt} inactiveIcon={faBoltSlash} />,
            onClick: onUpdateFeatureRole,
          },
          {
            children: (
              <>
                <FontAwesomeIcon icon={faTrash} />
                Delete
              </>
            ),
            onClick: onDeleteFeatureRole,
          },
        ]}
      />
    </PermissionWrapper>
  );
};
